export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14271.52bdae72.jpg";